declare namespace $ {

	export class $shm_hitalama_map_widget_float_form_string extends $mol_string {
	}
	
}

//# sourceMappingURL=string.view.tree.d.ts.map